import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
  SkeletonTextBlock,
} from '@/components/common/skeleton';

export const DesktopWifiScreenSkeleton: React.FC = () => (
  <SkeletonGroup>
    <View style={styles.row}>
      {/* Left column: Wifi info card */}
      <View style={styles.colLeft}>
        <SkeletonCard borderRadius={16} padding={16}>
          <SkeletonBone width={64} height={20} />
          <SkeletonBone width={160} height={20} />
          <SkeletonBone width={200} height={14} />
          <View style={styles.fieldGroup}>
            <SkeletonBone width={80} height={12} />
            <SkeletonBone width={140} height={14} />
          </View>
          <View style={styles.fieldGroup}>
            <SkeletonBone width={80} height={12} />
            <SkeletonBone width={120} height={14} />
          </View>
        </SkeletonCard>
      </View>

      {/* Right column: Support card */}
      <View style={styles.colRight}>
        <SkeletonCard borderRadius={16} padding={16}>
          <SkeletonBone width={140} height={18} />
          <SkeletonTextBlock lines={2} lineHeight={14} />
          <SkeletonBone width={120} height={36} borderRadius={8} />
        </SkeletonCard>
      </View>
    </View>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  colLeft: {
    flex: 1,
    marginRight: 8,
  },
  colRight: {
    flex: 1,
    marginLeft: 8,
  },
  fieldGroup: {
    gap: 4,
    marginTop: 8,
  },
});
